import { render, staticRenderFns } from "./Informacao.vue?vue&type=template&id=753e6026&scoped=true"
import script from "./Informacao.vue?vue&type=script&lang=js"
export * from "./Informacao.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=753e6026&prod&scoped=true&lang=css&external"
import style1 from "./Informacao.vue?vue&type=style&index=1&id=753e6026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753e6026",
  null
  
)

export default component.exports